import { useQuery } from '@apollo/client/react';
import {
  AuthenticatedLayoutDocument,
  AuthenticatedLayoutQuery,
} from 'graphql/types';
import React, { createContext, useContext } from 'react';

type User = AuthenticatedLayoutQuery['self'];

const UserContext = createContext<User>(null);

export const UserProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { data } = useQuery(AuthenticatedLayoutDocument);
  return (
    <UserContext.Provider value={data?.self ?? null}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
